module.exports = __webpack_public_path__ + "static/media/info-icon.1af2c414.svg";